import useDetectEffect from 'hooks/common/useDetectEffect';
import React from 'react';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';
import { v4 as uuidv4 } from 'uuid';

const DEFAULT_PARAMETERS = {};

export default function useFetch(host, id, { rewind = 0, urgency, defaultParameters = DEFAULT_PARAMETERS } = {}) {
  const setQueue = Recoil.useSetRecoilState(AppStore.communication.queues(host));
  const onRequest = React.useCallback(({ headers, parameters, timeout, events = {}, uuid: uuidR }, options) => {
    const uuid = uuidR || uuidv4();
    if (urgency) {
      setQueue(queue => {
        return [
          {
            host,
            id,
            headers,
            parameters: { ...defaultParameters, ...parameters },
            timeout,
            events,
            rewind,
            options,
            uuid,
            timestamp: Date.now()
          },
          ...queue
        ];
      });
    } else {
      setQueue(queue => [
        ...queue,
        {
          host,
          id,
          headers,
          parameters: { ...defaultParameters, ...parameters },
          timeout,
          events,
          rewind,
          options,
          uuid,
          timestamp: Date.now()
        }
      ]);
    }
  }, [urgency, host, id, defaultParameters, rewind]);
  // }, [urgency, setQueue, host, id, defaultParameters, rewind]);
  return onRequest;
}